export const incomeRentConstants = {

    INCOMERENT_REQUEST:  "INCOMERENT_REQUEST",
    INCOMERENT_SUCCESS:  "INCOMERENT_SUCCESS",
    INCOMERENT_FAILURE:  "INCOMERENT_FAILURE"
};